import { ProviderProps, useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';

export interface AideContextValue {
  allowEntry: boolean;
}

export const AideContext = createNamedContext<AideContextValue | null>('AideContext', null);

export const useAideContext = () => {
  const value = useContext(AideContext);

  if (!value) {
    throw new Error(
      'useAideContext hook should be used in a context of AideContextProvider component.',
    );
  }

  return value;
};

export const AideContextProvider = (props: ProviderProps<AideContextValue>) => {
  return <AideContext.Provider {...props} />;
};
